import appWithStyles, {
  WithStyles as AppWithStyles,
} from '@material-ui/core/styles/withStyles'

export { appWithStyles }

export type { AppWithStyles }
